import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  hoursAndInfo: {
    id: 'hoursAndInfo',
    defaultMessage: 'Hours & Info',
    description: 'The heading for a section that displays store information and opening hours.',
  },
  closesAt: {
    id: 'closesAt',
    defaultMessage: 'Closes at {time}',
    description: 'Displays the time at which a store closes.',
  },
  order: {
    id: 'order',
    defaultMessage: 'Order',
    description: 'Button text for a CTA that users can click to start an online order at a store.',
  },
  orderNow: {
    id: 'orderNow',
    defaultMessage: 'Order Now',
    description: 'Button text for a CTA that users can click to start an online order at a store.',
  },
  viewOffers: {
    id: 'viewOffers',
    defaultMessage: 'View Offers',
    description: 'The button text for a CTA that users can click to view a restaurants offers.',
  },
  select: {
    id: 'select',
    defaultMessage: 'Select',
    description:
      'The button text for a CTA that allows the user to select a restaurant without starting an order.',
  },
  selectThisStore: {
    id: 'selectThisStore',
    defaultMessage: 'Select this store',
    description:
      'The accessibility label for a CTA that allows the user to select a specific restaurant.',
  },
  orderAtThisStore: {
    id: 'orderAtThisStore',
    defaultMessage: 'Order at this store',
    description:
      'The accessibility label for a CTA that allows the user to start an online order at a specific restaurant.',
  },
  storeInfoAssistive: {
    id: 'storeInfoAssistive',
    defaultMessage: 'See information for this store',
    description: 'The accessibility label for a CTA that takes the user to store information.',
  },
});
